export default __webpack_public_path__ + "static/media/notepad.c966bc1b.webp";